import PropTypes from "prop-types";
import { useState } from "react";
import { ChevronDown, SquareM, Trash2 } from "lucide-react";

import { buttonVariants } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import RegistrantLeadStatusModal from "routes/leads/swoogo_registrants/RegistrantLeadStatusModal";
import ConfirmRemoveSessionRegistrantsDialog from "routes/swoogo/ConfirmRemoveSessionRegistrantsDialog";
import RemoveSessionRegistrantsDialog from "routes/swoogo/RemoveSessionRegistrantsDialog";

const RegistrantBulkActions = ({
  selectedData,
  uncheckAll,
  sessionId,
  canRemoveSessionRegistrants,
  canSetLeadStatus,
}) => {
  const [isRemoveOpen, setIsRemoveOpen] = useState(false);
  const [isLeadStatusOpen, setIsLeadStatusOpen] = useState(false);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger
          className={buttonVariants({ variant: "outline" })}
          disabled={selectedData.length === 0}
        >
          Actions
          <ChevronDown />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="tw:w-auto">
          {canSetLeadStatus && (
            <DropdownMenuGroup>
              <DropdownMenuItem onClick={() => setIsLeadStatusOpen(true)}>
                <SquareM />
                Set Meta Status
              </DropdownMenuItem>
            </DropdownMenuGroup>
          )}
          {canSetLeadStatus && canRemoveSessionRegistrants && (
            <DropdownMenuSeparator />
          )}
          {canRemoveSessionRegistrants && (
            <DropdownMenuGroup>
              <DropdownMenuItem
                variant="destructive"
                onClick={() => setIsRemoveOpen(true)}
              >
                <Trash2 />
                {sessionId == null
                  ? "Remove from Sessions"
                  : "Remove from Session"}
              </DropdownMenuItem>
            </DropdownMenuGroup>
          )}
        </DropdownMenuContent>
      </DropdownMenu>
      {isRemoveOpen &&
        (sessionId == null ? (
          <RemoveSessionRegistrantsDialog
            registrants={selectedData}
            onOpenChange={setIsRemoveOpen}
            onSuccess={uncheckAll}
          />
        ) : (
          <ConfirmRemoveSessionRegistrantsDialog
            registrants={selectedData}
            sessionId={sessionId}
            onOpenChange={setIsRemoveOpen}
            onSuccess={uncheckAll}
          />
        ))}
      {isLeadStatusOpen && (
        <RegistrantLeadStatusModal
          registrantIds={selectedData.map(registrant => registrant.id)}
          open
          onOpenChange={setIsLeadStatusOpen}
          onSuccess={uncheckAll}
        />
      )}
    </>
  );
};

RegistrantBulkActions.propTypes = {
  selectedData: PropTypes.array.isRequired,
  uncheckAll: PropTypes.func.isRequired,
  sessionId: PropTypes.number,
  canRemoveSessionRegistrants: PropTypes.bool,
  canSetLeadStatus: PropTypes.bool,
};

export default RegistrantBulkActions;
